import cn from 'clsx';
import PropTypes from 'prop-types';
import {useState} from 'react';

import CheckIcon from '@/public/icons/checkmark.svg';
import PlusOne from '@/src/howTo/components/feedback/PlusOne';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import css from '../../styles/FeedbackVote.module.css';

export const HIDE_TOOLTIP_DELAY = 3000;

export const TEST_IDS = {
  LIKE_BUTTON: 'like-button',
  DISLIKE_BUTTON: 'dislike-button',
};

const FeedbackVote = ({isVoted, onDislikeClick, onLikeClick}) => {
  const [isPlusOneShow, setPlusOneShow] = useState(false);

  const showPlusOn = () => {
    setPlusOneShow(true);
    setTimeout(() => {
      setPlusOneShow(false);
    }, HIDE_TOOLTIP_DELAY);
  };

  const handleLikeClick = () => {
    onLikeClick();
    showPlusOn();
  };

  return (
    <div className={css.mainWrapper}>
      <div className={css.voteWrapper}>
        <div className={css.voteText}>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_16}
            fontWeight={Text.FONT_WEIGHT.BOLD}
          >
            <TextLocal id={'wiki-how.was-article-helpful'} />
          </Text>
        </div>
        <div className={css.voteButtons}>
          {isPlusOneShow && (
            <div className={css.animatedPlusOne}>
              <PlusOne />
            </div>
          )}
          {!isVoted ? (
            <>
              <button
                className={css.voteButton}
                onClick={handleLikeClick}
                data-testid={TEST_IDS.LIKE_BUTTON}
              >
                <TextLocal id={'general.yes'} />
              </button>
              <button
                className={cn(css.voteButton, css.voteButtonDislike)}
                onClick={onDislikeClick}
                data-testid={TEST_IDS.DISLIKE_BUTTON}
              >
                <TextLocal id={'general.no'} />
              </button>
            </>
          ) : (
            <button className={css.voteButton}>
              <div className={css.voteIcon}>
                <CheckIcon />
              </div>
              <TextLocal id="wiki-how.voted" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

FeedbackVote.propTypes = {
  isVoted: PropTypes.bool.isRequired,
  onDislikeClick: PropTypes.func.isRequired,
  onLikeClick: PropTypes.func.isRequired,
};

export default FeedbackVote;
